var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectToneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.964,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3458 0.480076C15.5402 0.226771 19.0117 1.67245 21.7601 4.81712C24.3653 8.18776 25.0971 11.9358 23.9554 16.0613C22.6079 19.979 19.9753 22.6115 16.0577 23.959C11.9322 25.1007 8.18414 24.369 4.81351 21.7637C1.41621 18.7659 0.0151457 15.0089 0.610322 10.4928C1.33525 6.72847 3.34314 3.88171 6.634 1.95253C8.11277 1.14594 9.68342 0.655121 11.3458 0.480076ZM12.4167 2.19348C15.8727 2.29273 18.648 3.70272 20.7428 6.42344C22.7676 9.34564 23.2316 12.5047 22.1349 15.9007C20.9445 19.0009 18.7848 21.1069 15.6561 22.2188C11.4751 23.3868 7.86979 22.423 4.84028 19.3275C2.28608 16.2835 1.60786 12.8567 2.80562 9.04708C3.99607 5.9469 6.15569 3.84084 9.28441 2.72891C10.313 2.41324 11.3571 2.23476 12.4167 2.19348Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.957,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.1521 7.33371C6.36702 7.32482 6.5812 7.33376 6.79462 7.36048C7.07782 7.55431 7.34553 7.76848 7.59778 8.003C8.02656 8.22409 8.45491 8.20626 8.88283 7.94946C9.08346 7.7129 9.31546 7.51661 9.5789 7.36048C10.4624 7.24445 10.8461 7.6282 10.7301 8.51167C10.2674 9.25828 9.59807 9.71341 8.7222 9.87704C7.40904 10.0546 6.38276 9.59947 5.64343 8.51167C5.50882 7.97848 5.6784 7.58579 6.1521 7.33371Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.957,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7191 7.33371C14.934 7.32482 15.1482 7.33376 15.3616 7.36048C15.6448 7.55431 15.9126 7.76848 16.1648 8.003C16.5936 8.22409 17.0219 8.20626 17.4498 7.94946C17.6505 7.7129 17.8825 7.51661 18.1459 7.36048C19.0294 7.24445 19.4131 7.6282 19.2971 8.51167C18.8344 9.25828 18.1651 9.71341 17.2892 9.87704C15.9761 10.0546 14.9498 9.59947 14.2104 8.51167C14.0758 7.97848 14.2454 7.58579 14.7191 7.33371Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.961,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.86554 15.9007C8.08046 15.8918 8.29464 15.9008 8.50806 15.9275C8.96179 16.3061 9.44369 16.6453 9.95375 16.9448C11.7157 17.8305 13.4648 17.7948 15.201 16.8377C15.5709 16.6108 15.91 16.3431 16.2184 16.0346C17.2018 15.6976 17.6569 16.0456 17.5837 17.0787C17.3428 17.4624 17.0305 17.7748 16.6467 18.0157C14.4421 19.4831 12.104 19.733 9.63248 18.7653C8.8123 18.4136 8.08946 17.9228 7.46396 17.2929C7.17895 16.6971 7.31281 16.2331 7.86554 15.9007Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectToneIcon);
export default __webpack_public_path__ + "static/media/direct_tone_icon.bbfb77b1.svg";
export { ForwardRef as ReactComponent };